import { LS_AUTH_TOKEN } from "./../Constants/localStorageKeys";
import LocalStorageHelper from "./LocalStorageHelper";

export const getAuthToken = () => LocalStorageHelper.get(LS_AUTH_TOKEN);
export const setAuthToken = (value: any) => LocalStorageHelper.add(LS_AUTH_TOKEN, value);
